export const FETCH_SOLAR_POWER_VS_BATTERY_POWER_REQUEST =
  '[SolarPowerVsBatteryPower] FETCH_SOLAR_POWER_VS_BATTERY_POWER_REQUEST';
export const FETCH_SOLAR_POWER_VS_BATTERY_POWER_SUCCESS =
  '[SolarPowerVsBatteryPower] FETCH_SOLAR_POWER_VS_BATTERY_POWER_SUCCESS';
export const FETCH_SOLAR_POWER_VS_BATTERY_POWER_FAILURE =
  '[SolarPowerVsBatteryPower] FETCH_SOLAR_POWER_VS_BATTERY_POWER_FAILURE';
